import {makeStyles, Menu, MenuItem} from "@material-ui/core";
import {useRef, useState} from "react";

const useStyles = makeStyles(() => ({
  dotIcon: {
    width: 20,
    height: 20,
    cursor: 'pointer',
    verticalAlign:'middle'
  },
  menuItem: {
    padding: 0
  },
  btn: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#697683',
    textTransform: 'unset',
    marginRight: 30,
    marginLeft: 30,
    width: '100%'
  }
}));

interface IProps {
  onRenameList: () => void
  onDeleteList: () => void
}

function ListDotMenu(props: IProps) {
  const classes = useStyles();
  const { onRenameList, onDeleteList } = props;
  const anchorRef = useRef(null);
  const [openMenu, setOpenMenu] = useState(false);

  const handleMenuOpen = () => {
    setOpenMenu(true);
  };

  const handleMenuClose = () => {
    setOpenMenu(false);
  };

  const onRename = () => {
    setOpenMenu(false);
    onRenameList();
  };

  const onDelete = () => {
    setOpenMenu(false);
    onDeleteList();
  };

  return (
    <div>
      <img
        src={'/assets/icons/participant/list-table-dot.svg'}
        alt='dot menu'
        className={classes.dotIcon}
        ref={anchorRef}
        onClick={handleMenuOpen}
      />
      <Menu
        anchorEl={anchorRef.current}
        onClose={handleMenuClose}
        open={openMenu}
        PaperProps={{
          style: {width: 'auto', marginTop: 50, borderRadius: 12}
        }}
      >
        {['Rename', 'Delete List'].map((option, index) => (
          <MenuItem
            className={classes.menuItem}
            key={option}
            onClick={() => index === 0 ? onRename() : onDelete()}
          >
            <p className={classes.btn}>{option}</p>
          </MenuItem>
        ))}
      </Menu>
    </div>
  )
}

export default ListDotMenu;